export default __webpack_public_path__ + "static/media/Background 5_00066.78553539.png";